import { render, staticRenderFns } from "./preachingDetails.vue?vue&type=template&id=04efc99a&scoped=true&"
import script from "./preachingDetails.vue?vue&type=script&lang=js&"
export * from "./preachingDetails.vue?vue&type=script&lang=js&"
import style0 from "./preachingDetails.vue?vue&type=style&index=0&id=04efc99a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04efc99a",
  null
  
)

component.options.__file = "preachingDetails.vue"
export default component.exports